// Entry point for web client bundle

import { init, initAfterRender } from "../shared/flux/system/browserInit";
init();

import moment from "moment";
import { browserHistory } from "react-router";
import { getInitialReduxState, renderApp } from "../shared/flux/system/browser";
import * as CookieHelper from "../shared/helpers/cookieHelper";
import { LocalStorageHelper } from "@travellocal/utils/localStorageHelper";
import { GoogleAnalyticsHelper, setupGoogleOptimize } from "@travellocal/ui";
import { Auth } from "./../shared/state/reducers";
import { routeFactory } from "./routes";
import webReducers from "./state/reducers";
import { checkSsrHtml } from "../shared/helpers/ssrHelpers";

const initialState = getInitialReduxState() as IWebStoreReducerState;
initialState.user = Auth.getUserState();

// #576 migrate currency preference from local storage to cookies
const currencyPrefLs = LocalStorageHelper.getItem("currency");
if (currencyPrefLs != null) {
  CookieHelper.setCookie(CookieHelper.keys.currencyPref, currencyPrefLs, moment().utc().add(1, "y"));
  LocalStorageHelper.removeItem("currency");
}

browserHistory.listen((location) => {
  GoogleAnalyticsHelper.logPageView(location.pathname);
});

console.debug("Rendering web...");
const onRenderComplete = () => {
  performance.mark("render");
  initAfterRender();
}

// NB onload is triggered when all resources have finished loading
window.onload = () => {
  performance.mark("load");
  setupGoogleOptimize();
};

// #1968 Compare server rendered HTML to debug white flash from hydration differences.
const checkSsr = window.location.search.indexOf("check_ssr") > -1;
if (checkSsr) {
  checkSsrHtml();
}

renderApp(webReducers, routeFactory, initialState, onRenderComplete);
